import * as actionTypes from "../action-types";

export const setIsLoading = (payload) => ({ type: actionTypes.SET_IS_LOADING, payload });
export const setIsSidebarOpne = (payload) => ({ type: actionTypes.SET_IS_SIDEBAR_OPEN, payload });

//* Description Modal
export const openDescriptionModal = payload => ({ type: actionTypes.OPEN_DESCRIPTION_MODAL, payload });
export const closeDescriptionModal = () => ({ type: actionTypes.CLOSE_DESCRIPTION_MODAL });